import { TextField } from '@mui/material';
import React from 'react';

interface InputAreaFieldProps {
    placeholder: string;
    type: string;
    name: string;
    onTextChange: Function;
    width: string;
    value: string | number | null | undefined;
    noOfRows: number;
}

export function InputAreaField({
    placeholder,
    type,
    name,
    onTextChange,
    width,
    value,
    noOfRows
}: InputAreaFieldProps): JSX.Element {
    const onTextFieldChange = (
        event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
    ): void => {
        onTextChange(event.currentTarget.value);
    };

    return (
        <TextField
            multiline
            rows={noOfRows}
            fullWidth
            required
            margin="dense"
            id={name}
            type={type}
            name={name}
            placeholder={placeholder}
            value={value}
            onChange={(event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>): void =>
                onTextFieldChange(event)
            }
            sx={{
                width,
                marginBottom: '15px',
                backgroundColor: '#0000000B',
                color: '#00000099',
                font: 'normal normal normal 24px Roboto',
                border: 'none'
            }}
        />
    );
}
